const calendarSyncDisabled = process.env.NEXT_PUBLIC_GOOGLE_CALENDAR_SYNC_DISABLED === 'true';
const GOOGLE_CALENDAR_EVENT_SCOPE = 'https://www.googleapis.com/auth/calendar.events';
const GOOGLE_LOGIN_SCOPES = ['openid', 'profile', 'email'];

const CalendarFeatureService = {
  isCalendarSyncDisabled(): boolean {
    return calendarSyncDisabled;
  },

  isCalendarSyncEnabled(): boolean {
    return !calendarSyncDisabled;
  },

  getGoogleLoginScope(): string {
    const scopes = [...GOOGLE_LOGIN_SCOPES];

    if (this.isCalendarSyncEnabled()) {
      scopes.push(GOOGLE_CALENDAR_EVENT_SCOPE);
    }

    return scopes.join(' ');
  },

  getMicrosoftLoginScope(): string {
    const scopes = ['openid', 'profile', 'email', 'User.Read'];

    if (this.isCalendarSyncEnabled()) {
      scopes.push('offline_access', 'Calendars.ReadWrite');
    }

    return scopes.join(' ');
  },
};

export default CalendarFeatureService;
